import React, { useState, useMemo } from 'react';

import { useRouter } from 'next/router';

import UseToast from 'hooks/use-toast';



import Spinner from '@core/components/spinner/Spinner';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Pagination from '@mui/material/Pagination';

import { useQuery } from 'react-query';
import { coverLetterAll } from 'services/coverLetter';

import CoverLetterCard from 'components/pages/coverLetter/coverlettercard/CoverLetterCard';

import classes from './CoverLetterDataWrapper.module.scss';


const CoverLetterDataWrapper = ({ hasSubscription, showGoPremiumModal }) => {
    const router = useRouter();
    const { ToastContainer, toast } = UseToast();
    const value = useMemo(() => {
        return router?.query?.status || 'All';
    }, [router.query.status]);
    const handleChange = (event, newValue) => {
        handleContentTypeSelect(newValue);
    };
    const startPage = useMemo(() => {
        return router?.query?.page;
    }, [router.query.page]);
    const selectedContent = useMemo(() => {
        return router?.query?.status || 'All';
    }, [router.query.status]);
    const queryParams = router.query;
    const searchParams = Object.keys(queryParams).reduce((result, currentKey) => {
        const newKeyValue = `&${currentKey}=${queryParams[currentKey]}`;
        return result + newKeyValue;
    }, '?');

    const { data, isLoading, refetch } = useQuery(
        ['cover-letter-content', searchParams],
        () => coverLetterAll.GET(searchParams),
        {
            // cacheTime: 20 * 60 * 1000,
            // staleTime: 20 * 60 * 1000,
            cacheTime: 0,
            staleTime: 0,
            enabled: !!router.isReady
        }
    );

    const queryWithoutPage = () => {
        const { page, ...queryParams } = router.query;
        return queryParams;
    };

    const handleContentTypeSelect = (newType) => {
        const queryParamsWithoutPage = queryWithoutPage();
        if (newType === selectedContent) {
            return;
        } else if (newType === 'All') {
            const { status, ...queryParams } = queryParamsWithoutPage;
            router.replace(
                {
                    pathname: router.pathname,
                    query: { ...queryParams }
                },
                undefined,
                { shallow: true }
            );
        } else {
            router.replace(
                {
                    pathname: router.pathname,
                    query: { ...queryParamsWithoutPage, status: newType }
                },
                undefined,
                { shallow: true }
            );
        }
    };

    const handlePageChange = (newPage) => {
        const queryParams = router.query;
        if (newPage) {
            router.replace(
                {
                    pathname: router.pathname,
                    query: { ...queryParams, page: newPage }
                },
                undefined,
                { shallow: true }
            );
        } else {
            const { page, ...queryParams } = queryParams;
            router.replace(
                {
                    pathname: router.pathname,
                    query: { ...queryParams }
                },
                undefined,
                { shallow: true }
            );
        }
    };

    const deleteHandler = () => {
        refetch();
        toast('Cover letter deleted successfully. ', 'success');
    };


    return (
        <>
            <div className='container p-lg-0'>
                <div className="d-flex flex-column gap-4 w-100">
                    {data && !isLoading ? (
                        <>
                            <div className="d-flex flex-wrap flex-column">
                                <Box sx={{ width: '100%', typography: 'body1', marginBottom: '20px' }}>
                                    <TabContext value={value}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList className={classes["cover-letter-tabs"]} onChange={handleChange} aria-label="lab API tabs example">
                                                <Tab sx={{
                                                    '&.MuiButtonBase-root': {
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    },
                                                    '&.Mui-selected': {
                                                        fontSize: '12px',
                                                        fontWeight: '700'
                                                    }
                                                }} label="All" value="All" />
                                                <Tab sx={{
                                                    '&.MuiButtonBase-root': {
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    },
                                                    '&.Mui-selected': {
                                                        fontSize: '12px',
                                                        fontWeight: '700'
                                                    }
                                                }} label="Draft Cover Letters" value="draft" />
                                                <Tab sx={{
                                                    '&.MuiButtonBase-root': {
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    },
                                                    '&.Mui-selected': {
                                                        fontSize: '12px',
                                                        fontWeight: '700'
                                                    }
                                                }} label="Exported Cover Letters" value="exported" />
                                            </TabList>
                                        </Box>
                                    </TabContext>
                                </Box>
                                {data.data.results.map((content) => (
                                    <div key={content.id} className={`${classes['cover-letter-data-card-wrapper']} py-3`}>
                                        <CoverLetterCard
                                            data={content}
                                            deleteHandler={deleteHandler}
                                            hasSubscription={hasSubscription}
                                            showGoPremiumModal={showGoPremiumModal}
                                        />
                                    </div>
                                ))}
                            </div>
                            {data.data.count > 5 && (
                                <div className="d-flex align-items-center justify-content-center">
                                    <Pagination
                                        count={Math.ceil(data.data.count / 5)}
                                        page={startPage ? +startPage : 1}
                                        variant="outlined"
                                        shape="rounded"
                                        color="primary"
                                        onChange={(e, page) => {
                                            handlePageChange(page);
                                            window.scrollTo(0, 0);
                                        }}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="d-flex align-items-center justify-content-center w-100 py-5">
                            <Spinner />
                        </div>
                    )}
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default CoverLetterDataWrapper;